const UNITY_MULTIPLIER_MAP = {
    'ms': 1,
    'secs': 1000,
    'mins': 1000 * 60,
    'hrs': 1000 * 60 * 60,
    'days': 1000 * 60 * 60 * 24,
}

interface Params {
    key: string
    time: number
    unity?: keyof typeof UNITY_MULTIPLIER_MAP
}

export function blockKey({ key, time, unity = 'ms' }: Params) {
    const multiplier = UNITY_MULTIPLIER_MAP[unity]
    const msAmount = multiplier * time
    const expirationMs = msAmount + Date.now()
    const expirationDate = new Date(expirationMs)

    localStorage.setItem(key, expirationDate.toISOString())
}

export function isBlocked(key: string) {
    const expiresAt = localStorage.getItem(key)
    if (!expiresAt) return false

    return expiresAt > new Date().toISOString()
}
